import Link from "next/link"
import { useRouter } from "next/router"
import React, { useState, useEffect } from "react"
import clsx from "clsx"
import PropTypes from "prop-types"
import { useTranslation } from "i18n"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import {
  AppBar,
  Typography,
  Avatar,
  Toolbar,
  Box,
  useTheme,
  useMediaQuery,
  NoSsr
} from "@material-ui/core"

// Components
import Button from "components/shared/Button"

// Helpers
import { getAuthInfo, getPlatformURL } from "shared/helpers"

const useStyles = makeStyles(theme => ({
  appBarRoot: {
    backgroundColor: theme.palette.common.white
  },
  disableShadow: {
    boxShadow: "none"
  },
  flex: {
    flexGrow: 1
  },
  primaryBtn: {
    // marginLeft: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  toolbarRoot: {
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 0
    }
  }
}))

export default function StoreAppBar({ disableShadow, position }) {
  const classes = useStyles({ disableShadow })
  const { t } = useTranslation()
  const theme = useTheme()
  const { query } = useRouter()
  const smDown = useMediaQuery(theme.breakpoints.down("xs"))

  const [auth, setAuth] = useState(false)

  useEffect(() => {
    setAuth(getAuthInfo() ? true : false)
  }, [])

  return (
    <div>
      <AppBar
        classes={{
          root: classes.appBarRoot
        }}
        className={clsx({ [classes.disableShadow]: disableShadow })}
        position={position === "fixed" ? position : "static"}
      >
        <Toolbar classes={{ root: classes.toolbarRoot }}>
          <img
            style={{
              width: smDown ? 40 : 120,
              marginRight: smDown ? 8 : 8,
              marginLeft: smDown ? 8 : 0
            }}
            alt="suraasa"
            variant="rounded"
            src={
              smDown
                ? "/store/assets/logos/mini.webp"
                : "/store/assets/logos/full-dark.webp"
            }
          />

          <Button
            variant="contained"
            color="primary"
            component="a"
            href="/store"
            className={classes.primaryBtn}
            disableElevation
          >
            <Typography variant="body1">{t("Explore")}</Typography>
          </Button>

          {/* Spacer */}
          <div className={classes.flex}></div>

          {auth ? (
            <Button
              color="primary"
              // variant="contained"
              component="a"
              href={getPlatformURL("learn", "/home")}
            >
              <Typography variant="body1">{t("Go to Dashboard")}</Typography>
            </Button>
          ) : (
            <>
              <NoSsr>
                <Box pr={{ sm: 2 }}>
                  <Button
                    component="a"
                    href={
                      typeof window === "undefined"
                        ? getPlatformURL("learn", "/login")
                        : getPlatformURL(
                            "sso",
                            `/?platform=Student&redirect-url=${encodeURI(
                              window.location.origin +
                                `/sso?next=${window.location.pathname}`
                            )}`
                          )
                    }
                  >
                    <Typography variant="body1">{t("Log In")}</Typography>
                  </Button>
                </Box>
              </NoSsr>

              <Link
                href={{
                  pathname: "/talk-to-a-mentor",
                  query
                }}
                passHref
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.primaryBtn}
                >
                  <Typography variant="body1">Talk to a Mentor</Typography>
                </Button>
              </Link>
            </>
          )}
        </Toolbar>
      </AppBar>
    </div>
  )
}

StoreAppBar.defaultProps = {
  disableShadow: false
}

StoreAppBar.propTypes = {
  disableShadow: PropTypes.bool
}
